<template>
  <div>
    <div class="search_block">
      <Form :label-width="80" inline>
        <FormItem label="姓名">
          <Input placeholder="请输入" v-model="table.search.PatientName"></Input>
        </FormItem>
        <FormItem label="检查编号">
          <Input placeholder="请输入" v-model="table.search.AccessionNumber"></Input>
        </FormItem>
        <FormItem label="患者编号">
          <Input placeholder="请输入" v-model="table.search.ParentID"></Input>
        </FormItem>
        <FormItem label="检查类型">
          <Select placeholder="请选择" v-model="table.search.StudyModality" clearable>
            <Option
              v-for="(item, index) in ExamTypeSelect"
              :value="item.dictionaryValue"
              :key="index"
              >{{ item.dictionaryValue }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="医院编码">
          <Input placeholder="请输入" v-model="table.search.HospitalCode"></Input>
        </FormItem>
        <FormItem label="检查日期">
          <Col span="12">
            <DatePicker
              type="date"
              format="yyyyMMdd"
              v-model="table.search.ExamDate"
              @on-change="table.search.ExamDate = $event"
              placeholder="选择检查日期"
            ></DatePicker>
          </Col>
        </FormItem>
        <Button class="ml-5" type="primary" @click="search">查询</Button>
      </Form>
    </div>
    <DataTable
      class="mb-5"
      ref="dataTable"
      :columns="table.columns"
      :apiUrl="table.apiUrl"
      :search="table.search"
      height="500"
      @selectionChange="selectionChange"
    ></DataTable>
    <div class="ml-5 mt-5 text-center modal-foter">
      <Button @click="returnBack">关 闭</Button>
    </div>
  </div>
</template>

<script>
import DataTable from "@/components/DataTable.vue";
export default {
  props: ['value'],
  components: { DataTable },
  data() {
    return {
      table: {
        columns: [
          {
            title: "序号",
            key: "",
            type: "index",
            width: "60",
          },
          { width: "100", title: "医院编码", key: "organCode" },
          { width: "100", title: "患者编号", key: "parentID" },
          { width: "100", title: "检查编号", key: "accessionNumber" },
          { width: "100", title: "患者姓名", key: "patientName" },
          { width: "100", title: "患者年龄", key: "patientAge" },
          { width: "100", title: "出生日期", key: "patientBirthday" },
          { width: "100", title: "性别", key: "patientSex" },
          { width: "100", title: "检查类型", key: "studyModality" },
          { width: "100", title: "OOS存储状态", key: "oosUploadFlag" },
          { width: "100", title: "设备厂商", key: "deviceManufacture" },
          { width: "100", title: "检查部位名称", key: "examBodyName" },
          { width: "100", title: "检查日期", key: "examDate" },
          { width: "100", title: "检查项目名称", key: "examItemName" },
          { width: "100", title: "检查时间", key: "examTime" },
          { width: "100", title: "是否手动匹配", key: "handmatch" },
          { width: "100", title: "影像类型", key: "imgFileType" },
          { width: "100", title: "最后更新时间", key: "lastUpdateDate" },
          { width: "100", title: "存储路径", key: "pathDetail" },
          { width: "100", title: "RIS标记", key: "rISFlag" },
          { width: "100", title: "序列数量", key: "serieseCount" },
          { width: "100", title: "影像数量", key: "imageCount" },
          { width: "100", title: "层厚", key: "slicethickness" },
          { width: "100", title: "工作站名", key: "stationname" },
          { width: "100", title: "检查描述", key: "studyDescription" },
          { width: "100", title: "检查主键", key: "studyID" },
          { width: "100", title: "STUDYUID", key: "studyInstanceUID" },
          { width: "100", title: "窗位", key: "winCenter" },
          { width: "100", title: "窗宽", key: "winWide" },
          {
            title: "操作",
            fixed: "right",
            width: "80px",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color: "#3795C8",
                    },
                    on: {
                      click: () => {
                        this.matchingHandle(params.row);
                      },
                    },
                  },
                  "匹配"
                )
              ]);
            },
          },
        ],
        apiUrl: "StudyInfo/getList",
        search: {
          HospitalCode:this.value.hospitalID,
          ParentID:'',
          AccessionNumber:'',
          PatientName:'',
          StudyModality:'',
          ExamDate:''
        }
      },
      ExamTypeSelect: [],
    };
  },
  mounted(){
    // this.search.HospitalCode=this.value
    this.search()
    var _this = this;
    this.$common.getDictionaryByCode("JCLX").then((data) => {
      _this.ExamTypeSelect = data;
    });
  },
  methods:{
    search: function () {
      this.$refs.dataTable.initload();
    },
    matchingHandle(item){
      this.$api.post(`HomePage/UpStudyinfos?studyID=${item.studyID}&AccessionNumber=${this.value.accessionNum}`).then((rsp) => {
        if (rsp.data=="状态更新成功") {
          this.$Message.success("匹配成功");
          this.$emit('close')
        }else{
            this.$Message.console.error(rsp.data || '匹配失败');
        }
      });
    },
    returnBack(){
      this.$emit('close')
    }
  }
};
</script>

<style scoped lang="less">
  .search_block{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    background: #fff;
    // padding: 15px 0 15px;
    border-radius: 10px;
    // margin-bottom: 10px;
    .ivu-form-item{
        margin-bottom: 10px;
    }
    .ivu-form .ivu-form-item-label{
        color: #6E849E;
    }
    .ivu-select,.ivu-date-picker{
        width: 186px;
    }
  }
</style>